// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"1c6396a7","774":"f934315d","787":"b163a15e"}[chunkId] + ".chunk.js";
};